import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
	{
		path: "/",
		name: "home",
		component: HomeView,
		meta: {
			requireAuth: false
		}
	},
	{
		path: '/investor-flip',
      name: 'investor-flip',
		component: () =>
			import(/* webpackChunkName: "investor-flip" */ "../views/InvestorFlipListView.vue"),
		meta: {
			requireAuth: false,
			title: "Investor Flip Projects | K&M Remodeling Services"
		}
	},
	{
		path: '/investor-flip/:slug',
		name: 'investor-flip-project',
		component: () =>
			import(/* webpackChunkName: "investor-flip-project" */ "../views/InvestorFlipProjectView.vue"),
		props: true,
		meta: {
			requireAuth: false,
			title: "Investor Flip Project | K&M Remodeling Services"
		}
	},
	{
		path:"/privacy-policy",
		name:"privacyPolicy",
		component: () =>
			import(/* webpackChunkName: "privacy-policy" */ "../views/PrivacyPolicy.vue"),
		meta: {
			requireAuth: false,
			title: "Privacy Policy | K&M Remodeling Services"
		}
	},
	{
		path:"/kitchen-bath-charlotte-nc",
		name:"formKitchenBath",
		component: () =>
			import(/* webpackChunkName: "form-kitchen-bath" */ "../views/FormKitchenBath.vue"),
		meta: {
			requireAuth: false,
			title: "Kitchen Bath Form | K&M Remodeling Services"
		}
	},
	{
		path:"/kitchen-remodeling-pays-back",
		name:"formKitchenPaysBack",
		component: () =>
			import(/* webpackChunkName: "form-kitchen-pays-back" */ "../views/FormKitchenPaysBack.vue"),
		meta: {
			requireAuth: false,
			title: "Kitchen Remodeling Pays Back | K&M Remodeling Services"
		}
	},
	{
		path:"/kitchen-remodeling-charlotte-nc",
		name:"formNoSurprises",
		component: () =>
			import(/* webpackChunkName: "form-no-surprises" */ "../views/FormNoSurprises.vue"),
		meta: {
			requireAuth: false,
			title: "Kitchen Remodeling in Charlotte, NC | K&M"
		}
	},
	{
		path:"/home-renovation-charlotte-nc",
		name:"FormFullHomeRemodel",
		component: () =>
			import(/* webpackChunkName: "form-full-home-remodel" */ "../views/FormFullHomeRemodel.vue"),
		meta: {
			requireAuth: false,
			title: "Full Home Renovation | K&M Remodeling Services"
		}
	},
	{
		path:"/kitchen-remodeling-charlotte-summer-offer",
		name:"KitchenSummerOffer",
		component: () =>
			import(/* webpackChunkName: "kitchen-summer-offer" */ "../views/KitchenSummerOffer.vue"),
		meta: {
			requireAuth: false,
			title: "Kitchen Summer Offer | K&M Remodeling Services"
		}
	},
	{
	    path: "/kitchen-remodel-cost-calculator",
	    name: "kitchenCostCalculator",
	    component: () =>
		    import(/* webpackChunkName: "kitchen-cost-calculator" */ "../views/KitchenCostCalculator.vue"),
	    meta: {
		    requireAuth: false,
		    title: "Kitchen Remodel Cost Calculator | K&M Remodeling Services"
	   }
    },
	{
		path:"/thankyou",
		name:"thankyouPage",
		component: () =>
			import(/* webpackChunkName: "thankyouPage" */ "../views/ThankyouPage.vue"),
		meta: {
			requireAuth: false,
			title: "Thank You Page | K&M Remodeling Services",
			noindex: true
		}
	},
	
	{
		path: "/services",
		name: "services",
		component: () =>
			import(/* webpackChunkName: "services" */ "../views/ServicesView.vue"),
		meta: {
			requireAuth: false,
			title: "Our Services | K&M Remodeling Services"
		}
	},
	{
		path:"/our-portfolio",
		name:"portfolio",
		component: () =>
			import(/* webpackChunkName: "portfolio" */ "../views/PortfolioView.vue"),
		meta: {
			requireAuth: false,
			title: "Portfolio | K&M Remodeling Services"
		}
	},
	{
		path: "/contact",
		name: "contact",
		component: () =>
			import(/* webpackChunkName: "contact" */ "../views/ContactView.vue"),
		meta: {
			requireAuth: false,
			title: "Contact Us | K&M Remodeling Services"
		}
	},
	{
		path: "/faq",
		name: "faq",
		component: () =>
			import(/* webpackChunkName: "faq" */ "../views/FaqQuestion.vue"),
		meta: {
			requireAuth: false,
			title: "FAQ | K&M Remodeling Services"
		}
	},
	
	{
		path: "/login",
		name: "login",
		component: () =>
			import(/* webpackChunkName: "login" */ "../views/LoginPage.vue"),
		meta: {
			noindex: true
		}
	},
	{
		path: '/:pathMatch(.*)*',
		name: 'NotFound',
		component: () =>
			import(/* webpackChunkName: "notFound" */ "../components/NotFound.vue"),
		meta: {
			noindex: true
		}
	},

];


const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.query.scrollTo) {
      return false
      }
		if (
         to.name === 'projects' &&
         from.name === 'projects' &&
			to.query.keepScroll==='1'
      ) {
      return false
      }
		// если есть hash (#form-section)
		if (to.hash) {
			return {
				el: to.hash,
				behavior: "smooth"
			};
		}

		// если нажали назад / вперед в браузере
		if (savedPosition) {
			return savedPosition;
		}

		// по умолчанию вверх
		return { top: 0 };
	}
});

router.beforeEach((to, from, next) => {
	// <title> выставляется через useHead в App.vue по to.meta.title

	// Сохраняем utm_source в localStorage, чтобы не терять источник при переходах по сайту.
	// from.name === null только на самом первом заходе в этой вкладке (загрузка/перезагрузка страницы),
	// а не при клике по внутренним ссылкам — поэтому обычный внутренний переход метку не сбрасывает.
	const utmSource = to.query.utm_source;
	const isFreshVisit = from.name == null;

	if (utmSource) {
		localStorage.setItem('lead_source', utmSource);
	} else if (isFreshVisit) {
		localStorage.removeItem('lead_source');
	}

	next();
});

// Для отслеживания виртуальных Page View в GTM/GA4
router.afterEach((to) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'page_view',
		page_path: to.fullPath,
		page_title: to.meta.title || 'KM Remodeling Services'
	});
});

export default router;
